import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'

import * as styles from './BulletItemText.module.css'

/**
 * @typedef {object} BulletItemTextProps
 *
 * @property {string} [className]
 *
 * @property {boolean} [isSecondary]
 *
 * @property {string} [value]
 */

/**
 * @param {BulletItemTextProps} props
 */
function BulletItemText({
  className = styles.BulletItemText,
  isSecondary = true,
  value,
  ...textProps
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  return (
    <FloatingTooltip content={value} disabled={!overflow}>
      <Text
        {...textProps}
        className={className}
        isSecondary={isSecondary}
        ref={setContentOverflowRef}
      >
        {value}
      </Text>
    </FloatingTooltip>
  )
}

export default BulletItemText
